/**
 * CareStart Studio — aim/purpose options for facility variants (Phase 2).
 *
 * WHAT: Shared labels and keys for the variant creation form and public variant header.
 * WHY: Supervisors choose a human-readable purpose; `aimKey` is stored on the variant doc.
 * INVARIANT: `custom` requires `aimCustomText` when saving; care level still flows through
 *   deriveCareGuidance — aim changes framing only, not the safety ladder.
 */

export const CARESTART_AIM_OPTIONS = [
  {
    key: 'patient_self_triage',
    label: 'Patient self-triage',
    description:
      'Patient uses this on their own to decide where to go for care',
  },
  {
    key: 'ed_intake',
    label: 'ED intake',
    description: 'Staff-assisted triage at an Emergency Department front desk',
  },
  {
    key: 'walkin_intake',
    label: 'Walk-in clinic intake',
    description: 'Staff-assisted intake for a walk-in or urgent care clinic',
  },
  {
    key: 'scheduled_checkin',
    label: 'Scheduled visit check-in',
    description: 'Pre-visit screening for patients with scheduled appointments',
  },
  {
    key: 'custom',
    label: 'Custom (describe below)',
    description: null,
  },
];

const careStartAimOptions = { CARESTART_AIM_OPTIONS };
export default careStartAimOptions;
